import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FormText, TextArea } from '~/components/FormControl';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import { schema, initialValues } from './keyword.yup';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import { createNewKeywordApi, updateKeywordApi } from './keywordSlice';
import ApiValidationErrorDisplay from '~/components/ApiValidationErrorDisplay';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import DisplayFormikState from '~/components/DisplayFormikState';
import { API_PREFIX } from './keyword.api';
import { checkDuplicateName } from '~/utils/validators.yup';

function KeywordFormModal({ showModal, setShowModal, editedRow, setEditedRow }) {
    const handleClose = () => setShowModal(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { apiValidationErrors } = useSelector((state) => state.apiValidationError);
    const isCreateNew = () => {
        return isEmpty(editedRow);
    };
    const asyncApiCall = checkDuplicateName(editedRow?.name, API_PREFIX);

    return (
        <Formik
            initialValues={isCreateNew() ? initialValues : editedRow}
            enableReinitialize //this is to make formik re-render form when its initialValues got changed (ref: https://stackoverflow.com/a/53922113/11297747)
            onSubmit={(values, formikBag) => {
                if (isCreateNew()) {
                    dispatch(createNewKeywordApi({ navigate, values, formikBag, setShowModal }));
                } else {
                    const id = editedRow.id;
                    dispatch(updateKeywordApi({ navigate, id, values, formikBag, setShowModal }));
                }
            }}
            validationSchema={schema()}
            validateOnChange={false}
        >
            {(props) => {
                // eslint-disable-next-line react/prop-types
                const { handleSubmit, isSubmitting } = props;

                return (
                    <Modal
                        show={showModal}
                        onHide={handleClose}
                        centered
                        onExited={() => {
                            // clear all forms value upon exit (already did at thunk func).
                            // resetForm({
                            //     values: initialValues,
                            // });

                            setEditedRow({}); //must set editedRow to `null`, else `editedRow` will still be dangling even after modal is closed.
                        }}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Keyword</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <FormText
                                sm="12"
                                name="name"
                                asyncApiCall={asyncApiCall}
                            />
                            <TextArea
                                name="description"
                                rows={2}
                                sm="12"
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="secondary"
                                onClick={handleClose}
                                disabled={isSubmitting}
                            >
                                Close
                            </Button>
                            <Button
                                variant="primary"
                                onClick={handleSubmit}
                            >
                                Submit
                            </Button>
                        </Modal.Footer>
                        <ApiValidationErrorDisplay
                            errors={apiValidationErrors}
                            clearError={clearApiValidationErrors}
                        />
                        <DisplayFormikState {...props} />
                    </Modal>
                );
            }}
        </Formik>
    );
}

KeywordFormModal.defaultProps = {
    editedRow: {},
};
KeywordFormModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    setShowModal: PropTypes.func.isRequired,
    editedRow: PropTypes.object,
    setEditedRow: PropTypes.func.isRequired,
};
export default React.memo(KeywordFormModal);
